// Wrapper kring <RelatedKnowledge /> som auto-matchar artiklar via topic-tags.
// Tjänstesidor behöver bara skicka in en lista topics — vi väljer top N
// från det publicerade kunskapsbiblioteket.
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { RelatedKnowledge } from "@/components/site/RelatedKnowledge";
import { getRelatedKnowledge } from "@/lib/related-knowledge.functions";

interface Props {
  topics: string[];
  exclude?: string[];
  limit?: number;
  eyebrow?: string;
  title?: string;
}

export function RelatedKnowledgeAuto({
  topics,
  exclude,
  limit = 3,
  eyebrow,
  title,
}: Props) {
  const fetchRelated = useServerFn(getRelatedKnowledge);
  const { data } = useQuery({
    queryKey: ["related-knowledge", topics, exclude, limit],
    queryFn: () => fetchRelated({ data: { topics, exclude, limit } }),
    staleTime: 5 * 60 * 1000,
  });

  if (!data?.items?.length) return null;
  return (
    <RelatedKnowledge eyebrow={eyebrow} title={title} items={data.items} />
  );
}
